import { StatsigProvider, useClientAsyncInit } from '@statsig/react-bindings'
// External Imports
import React from 'react'
import { context, LOCALE, RUNTIME_ENVIRONMENT, UUID } from 'src/dataLayer/env'
// Internal Imports
import { getTrackingUUID } from 'src/dataLayer/localData/cookies'
import { LoadingContent } from 'src/viewLayer/components/shared/LoadingContent/LoadingContent'

export function StatsigProviderWrapper({ children }) {
  const trackingUuid = getTrackingUUID() || ''
  const statsigClientApiKey = context?.statsig_client_api_key

  if (!statsigClientApiKey) {
    return children
  }
  const { client, isLoading } = useClientAsyncInit(
    statsigClientApiKey,
    {
      customIDs: { tracking_uuid: trackingUuid },
      locale: LOCALE,
      userID: UUID,
    },
    { environment: { tier: RUNTIME_ENVIRONMENT ?? 'staging' } },
  )

  if (isLoading) {
    return <LoadingContent />
  }

  return <StatsigProvider client={client}>{children}</StatsigProvider>
}
